export default __webpack_public_path__ + "static/media/Burned Band of Smoking Cinders.f35bbe14.jpg";